<span class="dvb-versandart-badge">
    <span class="badge"
          uib-tooltip="{{vm.tooltip}}"
          tooltip-placement="top-left"
          tooltip-enable="{{vm.versandart === 'EMAIL'}}"
          data-translate="{{'COMMON.VERSANDART_' + vm.versandart}}">
    </span>
</span>
